import { ISettingValues } from '../../Settings/ISettings'
import { checkIfCustomDuration } from './checkIfCustomDuration'

export const requiresEmailValidation = (settings: ISettingValues): boolean =>
  Boolean(
    settings.onlineAppointmentsExistingCustomersOnly ||
      settings.isCertainServiceBlock ||
      checkIfCustomDuration(settings) ||
      settings.onlineAppointmentsDepositOnlyForNewCustomers
  )

export const needsCpRedirectForKnownCustomer = (
  settings: ISettingValues
): boolean =>
  Boolean(
    settings.onlineAppointmentsExistingCustomersOnly ||
      checkIfCustomDuration(settings)
  )

export const blocksUnknownCustomer = (settings: ISettingValues): boolean =>
  Boolean(settings.onlineAppointmentsExistingCustomersOnly)
